import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import ReactUtils from '../../packages/react-utils/react-utils.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import styles from './button.scss.js';
import { BUTTON_APPEARANCES, BUTTON_SIZES, BUTTON_DISPLAYS, BUTTON_ELEMS, BUTTON_TYPES } from './types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('btn', styles);
var Button = function (_a) {
  var appearance = _a.appearance,
    RouterLink = _a.RouterLink,
    extraClasses = _a.extraClasses,
    innerRef = _a.innerRef,
    link = _a.link,
    loading = _a.loading,
    display = _a.display,
    children = _a.children,
    size = _a.size,
    _b = _a.type,
    type = _b === void 0 ? 'button' : _b,
    _c = _a.Elem,
    Elem = _c === void 0 ? 'button' : _c,
    rest = __rest(_a, ["appearance", "RouterLink", "extraClasses", "innerRef", "link", "loading", "display", "children", "size", "type", "Elem"]);
  var buttonProps = __assign(__assign({
    className: bem.b([appearance, display, size, {
      link: link,
      loading: loading
    }], extraClasses)
  }, loading && {
    'aria-live': 'polite',
    'aria-busy': 'true'
  }), rest);
  var buttonChildren = ReactUtils.mapRecursively(children, function (child) {
    if (ReactUtils.getElementName(child) === 'Icon') {
      var iconComp = child;
      return /*#__PURE__*/React__default__default.cloneElement(iconComp, {
        extraClasses: PropsUtils.handleExtraClasses(iconComp, bem.e('icon'))
      });
    }
    return child;
  });
  var routerLinkProps = __assign(__assign(__assign({}, innerRef ? {
    innerRef: innerRef
  } : {}), {
    to: rest.href || rest.to || ''
  }), buttonProps);
  return RouterLink ? /*#__PURE__*/React__default__default.createElement(RouterLink, __assign({}, routerLinkProps), buttonChildren) : /*#__PURE__*/React__default__default.createElement(Elem, __assign({
    ref: innerRef
  }, Elem === 'button' && {
    type: type
  }, buttonProps), buttonChildren);
};
Button.displayName = 'Button';
Button.defaultProps = {
  size: undefined,
  appearance: undefined,
  display: undefined,
  Elem: 'button',
  RouterLink: undefined,
  extraClasses: '',
  loading: false,
  type: 'button',
  innerRef: undefined,
  link: false
};
Button.propTypes = {
  appearance: PropTypes__default.oneOf(BUTTON_APPEARANCES),
  size: PropTypes__default.oneOf(BUTTON_SIZES),
  /* eslint-disable-next-line react/require-default-props */
  children: function (_a) {
    var ariaLabel = _a["aria-label"],
      children = _a.children;
    // if no aria label nor children throw validation error
    return !ariaLabel && !children ? new Error('Either children or aria-label are required for Button component') : null;
  },
  display: PropTypes__default.oneOf(BUTTON_DISPLAYS),
  Elem: PropTypes__default.oneOf(BUTTON_ELEMS),
  RouterLink: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object]),
  extraClasses: PropTypes__default.string,
  innerRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.object
  })]),
  link: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  type: PropTypes__default.oneOf(BUTTON_TYPES)
};
var Button$1 = Injecss(Button, styles);

export { Button, Button$1 as default };
